module.exports = __webpack_public_path__ + "img/49_10.8c5c75e6.png";